/**
 * Cometa Taller · JavaScript Funcional de Interfaz (ZERO dependencias de GSAP)
 *
 * Contiene toda la lógica crítica de compra e interacción que DEBE funcionar
 * aun si GSAP falla, tarda o es bloqueado:
 * - Navegación accesible y Mega-menú
 * - Selector interactivo de paletas (Ficha y configurador)
 * - Filtros de catálogo sin recarga
 */

import { initNav } from './nav.js';
import { initPaleta } from './paleta.js';
import { initAcordeon } from './acordeon.js';
import { initCantidad } from './cantidad.js';
import { initConfigurador } from './configurador.js';

function init() {
  initNav();
  initPaleta();
  initAcordeon();
  initCantidad();
  initConfigurador();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
